import React, { useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { FaCalendar } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";

const Calendario = ({ value, handleChange, error }) => {
	useEffect(() => {
		registerLocale("es", es);
	}, []);
	return (
		<div className='input-icon flex'>
			<DatePicker
				locale='es'
				className={`form-control ${error ? "red-border" : ""}`}
				dateFormat={"yyyy-MM-dd"}
				value={value}
				selected={value}
				onChange={(date) => {
					handleChange(date);
				}}
				showMonthDropdown
				showYearDropdown
				dropdownMode='select'
			/>
			<FaCalendar />
		</div>
	);
};

export default Calendario;
